import { fetcher } from '@commenda/utils';

export async function deleteCredential(credentialId: string) {
  const response = await fetcher(`credentials/${credentialId}`, {
    method: 'DELETE',
  });

  return response;
}
